import script from "./MST01_001POS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST01_001POS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__